import request from '@/utils/request'


/**
 * 支付宝提现
 */
export function alipayWithdraw(data) {
  return request({
    url: '/index/withdraw/alipayWithdraw',
    method: 'post',
    data
  })
}

/**
 * 获取用户当前可提现的最大金额
 */
export function getUserMaxCanWithdraw(data) {
    return request({
        url: '/index/withdraw/getUserMaxCanWithdraw',
        method: 'post',
        data
    })
}





// WEBPACK FOOTER //
// ./src/api/withdraw.js